import React from 'react';

// Define colors for consistent styling based on our app's color scheme
const COLORS = {
  primary: '#243444',
  secondary: '#D2BA7B',
  light: '#FFFAFA',
  gray: '#4C5454',
  danger: '#7C1227'
};

const SubscriptionSelector = ({ selectedTier, onSelectTier }) => {
  // Subscription tiers with features and pricing
  const subscriptionTiers = [
    {
      id: 'Monthly',
      name: 'Monthly Subscription',
      price: '$250/month',
      features: [
        'Full access to all resilience templates',
        'Comprehensive assessment capabilities',
        'Detailed maturity reports',
        'Gap analysis',
        'Implementation Roadmaps',
        'Progress tracking',
        'Email support',
        'Single user',
        'No long-term commitment'
      ],
      recommended: false,
      productId: 'prod_Sf5xZTiSBQawD1'
    },
    {
      id: 'SingleOrg',
      name: 'Single Organization',
      price: '$2,500/year',
      features: [
        'Full access to all resilience templates',
        'Comprehensive assessment capabilities',
        'Detailed reports and analytics',
        'Up to 5 users per subscription',
        'Contact info@brnavigator.com for additional users',
        'Email support',
        'Limited to maturity assessments for ONE organization only',
        '$500 discount available (annual plan only)'
      ],
      recommended: false,
      productId: 'price_1RSwInBdbdJ6KuDNmj7GwroI'
    },
    {
      id: 'MultiOrg',
      name: 'Multiple Organizations',
      price: '$6,500/year',
      features: [
        'Full access to all resilience templates',
        'Comprehensive assessment capabilities',
        'Detailed reports and analytics',
        'Up to 5 users per subscription',
        'Contact info@brnavigator.com for additional users',
        'Email support',
        'Perform maturity assessments for MULTIPLE organizations',
        'Ideal for consultants and third-party management'
      ],
      recommended: true,
      productId: 'price_1RSwJGBdbdJ6KuDN54wFMJAZ'
    }
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Choose Your Subscription Plan</h2>
      <p style={styles.subtitle}>Select the plan that best fits your organization's needs</p>
      
      <div style={styles.tiersContainer}>
        {subscriptionTiers.map(tier => (
          <div 
            key={tier.id}
            style={{
              ...styles.tierCard,
              ...(selectedTier === tier.id ? styles.selectedTier : {}),
              ...(tier.recommended ? styles.recommendedTier : {})
            }}
            onClick={() => onSelectTier(tier.id)}
          >
            {tier.recommended && (
              <div style={styles.recommendedBadge}>
                Recommended
              </div>
            )}
            
            <h3 style={styles.tierName}>{tier.name}</h3>
            <p style={styles.tierPrice}>{tier.price}</p>
            
            <ul style={styles.featuresList}>
              {tier.features.map((feature, index) => (
                <li key={index} style={styles.featureItem}>
                  ✓ {feature}
                </li>
              ))}
            </ul>
            
            <button 
              style={{
                ...styles.selectButton,
                ...(selectedTier === tier.id ? styles.selectedButton : {})
              }}
              onClick={() => onSelectTier(tier.id)}
            >
              {selectedTier === tier.id ? 'Selected' : 'Select Plan'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    backgroundColor: COLORS.light,
    borderRadius: '8px',
    maxWidth: '1000px',
    margin: '0 auto'
  },
  title: {
    color: COLORS.primary,
    textAlign: 'center',
    marginBottom: '10px'
  },
  subtitle: {
    color: COLORS.gray,
    textAlign: 'center',
    marginBottom: '30px'
  },
  tiersContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap'
  },
  tierCard: {
    flex: '1 1 300px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    backgroundColor: '#fff'
  },
  selectedTier: {
    borderColor: COLORS.secondary,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    transform: 'translateY(-5px)'
  },
  recommendedTier: {
    borderColor: COLORS.secondary,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
  },
  recommendedBadge: {
    position: 'absolute',
    top: '-12px',
    right: '20px',
    backgroundColor: COLORS.secondary,
    color: COLORS.primary,
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  tierName: {
    color: COLORS.primary,
    fontSize: '20px',
    marginBottom: '5px'
  },
  tierPrice: {
    color: COLORS.primary,
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px'
  },
  featuresList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 20px 0',
    flex: 1
  },
  featureItem: {
    padding: '8px 0',
    color: COLORS.gray,
    borderBottom: '1px solid #f0f0f0'
  },
  selectButton: {
    backgroundColor: COLORS.primary,
    color: COLORS.light,
    border: 'none',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: 'auto'
  },
  selectedButton: {
    backgroundColor: COLORS.secondary,
    color: COLORS.primary
  }
};

export default SubscriptionSelector;
